import styled from 'styled-components';
import { fonts } from '../../styles/constants';

export const FooterMinimalWrapper = styled.footer`
  padding: 18px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 12px;

  ${({ theme }) => theme.mediaQuery.xl} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const FooterMinimalCopyright = styled.div`
  font-family: ${fonts.fontFamily.primary};
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  ${({ theme }) => theme.mediaQuery.xl} {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const FooterMinimalLinksContainer = styled.div`
  display: flex;
  column-gap: 12px;

  ${({ theme }) => theme.mediaQuery.xl} {
    column-gap: 24px;
  }
`;
